import type { ProgressSpinnerDesignTokens } from '@primeuix/themes/types/progressspinner'

export default {
  colorScheme: {
    dark: {
      root: {
        colorOne: '{pink.400}',
        colorTwo: '{sky.400}',
        colorFour: '{amber.400}',
        colorThree: '{emerald.400}',
      },
    },
    light: {
      root: {
        colorOne: '{primary.500}',
        colorTwo: '{primary.500}',
        colorFour: '{primary.500}',
        colorThree: '{primary.500}',
      },
    },
  },
} satisfies ProgressSpinnerDesignTokens
